var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"logo-img",attrs:{"src":_vm.$store.state.campaign.logo}})}
var staticRenderFns = []

export { render, staticRenderFns }